import { ProfileItem } from "qp-ui-interface";
import { LocalStorageKeys } from "../LocalStorageKeys";
import { LocalStorageService } from "../services/local-storage/local-storage.service";

/**
 * Check if should ask for a PIN on the profile change.
 *
 * @param currentProfile - The current profile.
 * @param nextProfile - The next profile.
 * @returns A boolean indicating whether a PIN should be asked for the profile change.
 */
export const checkProfileChange = (currentProfile: ProfileItem, nextProfile: ProfileItem): boolean => {
  return currentProfile && currentProfile.pt.toLowerCase() === 'kids' && nextProfile.pt.toLowerCase() === 'main';
}

/**
 * Get the selected profile from the local storage.
 *
 * @returns The selected profile from the local storage, or the first profile if it doesn't exist.
 */
export const getSelectedProfileFromStorage = (localStorage: LocalStorageService): ProfileItem | null => {
  if (!localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE)) {
    const profiles = JSON.parse(localStorage.getItem(LocalStorageKeys.PROFILES) ?? '[]');
    const profile = profiles.find(pf => pf.pt === 'main');
    if (profile) localStorage.setItem(LocalStorageKeys.SELECTED_PROFILE, JSON.stringify(profile));
    return profile;
  }
  return JSON.parse(localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE));
}

/**
 * Get the profile from the local storage based on the provided profile type.
 *
 * @param pt - The profile type.
 * @returns The profile from the local storage with the provided profile type, or undefined if it doesn't exist.
 */
export const getProfileFromStorage = (pt: string, localStorage: LocalStorageService): ProfileItem | undefined => {
  const profiles = JSON.parse(localStorage.getItem(LocalStorageKeys.PROFILES) ?? '[]');
  return profiles.find(pf => pf.pt === pt);
}

/**
 * Check if the selected profile is adult
 * @returns 
 */
export const isAdultProfile = (localStorage: LocalStorageService): boolean => {
  const profile = getProfileFromStorage('main', localStorage);
  return profile?.id === localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID)
}

/**
 * Return the selecte profile type
 * if there is no profile selected, return empty string
 * @returns 
 */
export const getProfileType = (localStorage: LocalStorageService): string => {
  const profile = localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE) ? JSON.parse(localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE)) : undefined;
  const pt = (profile?.pt ?? 'main');
  return pt.replace('main', 'normal');
}